import React from "react";
import { motion } from "framer-motion";
import { Form } from "react-bootstrap";

export default function SystemGdprCookies() {
  return (
    <motion.div
      className="card container py-3"
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
    >
      {/* TITLE */}
      <motion.h5
        className="fw-semblod mb-3 text-primary"
        initial={{ opacity: 0, x: -20 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 0.1 }}
      >
        GDPR Cookies
      </motion.h5>

      {/* CARD */}
      <motion.div
        className="card shadow-sm border-0"
        initial={{ opacity: 0, scale: 0.97 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 0.2 }}
      >
        <div className="card-body">

          <Form>

            {/* CONSENT TEXT */}
            <div className="row mb-3">
              <div className="col-md-3">
                <Form.Label>Cookies Consent Text</Form.Label>
              </div>
              <div className="col-md-6">
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="Enter consent message..."
                />
              </div>
            </div>

            {/* POSITION */}
            <div className="row mb-3 align-items-center">
              <div className="col-md-3">
                <Form.Label>Cookies Position</Form.Label>
              </div>
              <div className="col-md-4">
                <Form.Select>
                  <option>----- Select -----</option>
                  <option>Top</option>
                  <option>Bottom</option>
                  <option>Popup</option>
                </Form.Select>
              </div>
            </div>

            {/* ACCEPT TEXT */}
            <div className="row mb-3 align-items-center">
              <div className="col-md-3">
                <Form.Label>Agree Button Text</Form.Label>
              </div>
              <div className="col-md-4">
                <Form.Control type="text" placeholder="Accept" />
              </div>
            </div>

            {/* DECLINE TEXT */}
            <div className="row mb-3 align-items-center">
              <div className="col-md-3">
                <Form.Label>Decline Button Text</Form.Label>
              </div>
              <div className="col-md-4">
                <Form.Control type="text" placeholder="Decline" />
              </div>
            </div>

            {/* TOGGLE */}
            <div className="row mb-3 align-items-center">
              <div className="col-md-3">
                <Form.Label>Show Decline Button</Form.Label>
              </div>
              <div className="col-md-4">
                <Form.Check type="switch" />
              </div>
            </div>

            {/* LINK */}
            <div className="row mb-3 align-items-center">
              <div className="col-md-3">
                <Form.Label>Cookies Page Link</Form.Label>
              </div>
              <div className="col-md-4">
                <Form.Control type="text" placeholder="/cookies-policy" />
              </div>
            </div>

          </Form>
        </div>
      </motion.div>

      {/* FOOTER */}
      <motion.div
        className="d-flex justify-content-end gap-2 mt-4"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.3 }}
      >
        <motion.button
          whileTap={{ scale: 0.9 }}
          className="btn btn-outline-secondary"
        >
          Cancel
        </motion.button>

        <motion.button
          whileTap={{ scale: 0.9 }}
          className="btn btn-outline-success"
        >
          Save Changes
        </motion.button>
      </motion.div>
    </motion.div>
  );
}